/* tslint:disable:max-classes-per-file */

import {
  Injectable,
  Injector,
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { getPulseAngularElementsForChunk } from './angular-element-decorator';
import { PULSE_ELEMENTS_CHUNK } from './model';

@Injectable()
export class CustomElementsInjector {
  constructor(private injector: Injector) {}

  public injectCustomElements(chunkName: PULSE_ELEMENTS_CHUNK) {
    const elms = getPulseAngularElementsForChunk(chunkName);
    elms.forEach(({ constructor, selector }) => {
      // tslint:disable-next-line:no-any
      const customElm = createCustomElement(constructor as any, {
        injector: this.injector,
      });
      customElements.define(selector, customElm);
    });
  }
}

@NgModule({
  providers: [CustomElementsInjector],
})
export class ModuleWithPulseElements {
  public static forElementsChunk(
    chunk: PULSE_ELEMENTS_CHUNK,
  ): ModuleWithProviders<ModuleWithPulseElements> {
    return {
      ngModule: ModuleWithPulseElements,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = ((service: CustomElementsInjector) => () => {
            service.injectCustomElements(chunk);
          })(inject(CustomElementsInjector));
          return initializerFn();
        }),
      ],
    };
  }
}
